import React, { Component } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

export default class PatientSurvey extends Component {
  constructor() {
    super();

    this.state = {
      surveyData: [],
      pageNum: null,
      paginationValue: 5,
      isLoading: true,
    };
  }
  componentDidMount() {
    var thisController = this;

    setTimeout(() => {
      thisController.fetchSurvey();
    }, 300);
  }

  fetchSurvey() {
    var thisController = this;
    let patientProcedureId = localStorage.getItem("patientProcedureId");
    var surveyGroupId;

    $.ajax({
      url: "/my-jeeva-api/fetch-treatment-survey",
      // url: '/my-jeeva-api/fetch-survey',

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        // 'Authorization': "Bearer " + "cffbd23e-3031-4c09-843c-19ab5ce11bb0",
      },
      data: {
        // procedureId: localStorage.getItem("procedureId")
        procedureId: patientProcedureId
      },
      success: function (res) {
        if (res.success == true) {
          thisController.state.surveyData = res.result;
          localStorage.setItem("survey_treatments", JSON.stringify(res.result));
          surveyGroupId: JSON.parse(localStorage.getItem("survey_treatments"))[
            "surveyGroupId"
          ];

          // console.log(surveyData);
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
        }
      },
    });
  }

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no survey present. </p>
    </div>
  );

  showSurveyResult (id, title) {
    localStorage.setItem("surveyIdOfTreatment", id);
    localStorage.setItem("surveyTitle", title);
    this.props.history.push({
      pathname: "/projectmgmt/view-patient-survey-result",
    });
  }
  setSurveyIdToLocal(id, title) {
    localStorage.setItem("surveyIdOfTreatment", id);
    localStorage.setItem("surveyTitle", title);
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field].toLowerCase();
    const b = rowB[field].toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  getColumns() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Name</b>,
        width : "75vw",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('title'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.title}
          </div>
        ),
      },

      {
        name: (
          <div Align="center">
            <b style={{ fontSize: "16px" }}>Action</b>
          </div>
        ),
        selector: (row) => (
          <div
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              width: "100%",
              textAlign : "start"
            }}
          >
            {/* <Link
              to="/projectmgmt/view-patient-survey-result"
              onClick={() => {
                this.setSurveyIdToLocal(row.id, row.title);
              }}
            > */}
              <button
                style={{
                  backgroundColor: "#282a65",
                  border: "none",
                  color: "white",
                  borderRadius: "5px",
                  padding: "5px",
                }}
                onClick={
                  () => {
                    this.showSurveyResult(row.id, row.title);
                  }
                }
              >
                View Results
              </button>
            {/* </Link> */}
          </div>
        ),
        // ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ];
    return columns;
  }

  render() {
    return (
      <div className="main-journal" style={{ margin: "auto" }}>

      <div className="row">
        <div className="col-sm-4" style={{ marginTop: '16px' }}  >
            <Link to="/projectmgmt/reports/view-survey">
              <img src="./assets/images/arrow.svg"
                style={{ paddingRight: "30%", cursor: 'pointer' }}
              />
            </Link>
          </div>
          <div className="col-sm-4">
        <h6
          className="nav-item"
          style={{
            color: "#282a65",
             textAlign: 'center', 
             marginTop: '16px' 
          }}
        >
          Surveys of {localStorage.getItem("surveyPatientName")}
        </h6>
        </div>
      </div>
        <br />
        <div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
          {this.state.isLoading && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>Loading ...</p>
            </div>
          )}
          {!this.state.isLoading && this.state.surveyData.length === 0 && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>There are no survey records to display </p>
            </div>
          )}
          {this.state.surveyData.length > 0 && (
            <DataTable
              columns={this.getColumns()}
              data={this.state.surveyData}
              defaultPageSize={6}
              onPageChange={this.onPageChange}
              pagination={this.state.paginationValue}
              noDataComponent={<this.CustomNoDataComponent />}
            />)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientSurvey.js